import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { hot } from "react-hot-loader";

// utils
import { ThemeProvider, CssBaseline } from "@material-ui/core";
import theme from "@/utils/theme";
import { removeOldStudentData } from "@/utils/localStorage";

// components
import Router from "./Router";

class Root extends Component {
    componentDidMount() {
        removeOldStudentData();
    }
    render() {
        const { store, history } = this.props;
        return (
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Router history={history} />
                </ThemeProvider>
            </Provider>
        );
    }
}

Root.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default hot(module)(Root);
